import React from 'react';
import SvgIcon from '../SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
export default function PlayIcon(props) {
  return (
    <SvgIcon title="Play Video" viewBox="0 0 24 24" {...props}>
      <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 16.5V7.5L16 12L10 16.5Z" />
    </SvgIcon>
  );
}
